module.exports = __webpack_public_path__ + "fonts/ProximaNovaACond-Bold.40262b3250ee712f9684c9ae4b45fe8a.woff2";